export default "__VITE_ASSET__CNG4imoj__"